import { ElementAttribute } from "../../../library-js/dom-tools/ElementAttribute";
import { ElementType } from "../../../library-js/dom-tools/ElementType";
import { RegExpUtility } from "../../../library-js/text/RegExpUtility";
import { Cookies } from "../../../library-js/php/cookie-info/Cookies";
import { Rokojori } from "../Rokojori";
import { OnClick } from "../../../library-js/dom-tools/EventListeners";
import { PageHandler } from "../../../library-js/dom-tools/PageHandler";
import { Overlay } from "../overlay/Overlay";
import { ClassFlag } from "../../../library-js/dom-tools/ClassFlag";
import { OverlayHint } from "../overlay/OverlayHint";
import { HTMLEditor } from "../../../library-js/dom-tools/HTMLEditor";
import { SmartLink } from "../../../library-js/app/SmartLink";
import { DOMOrientation } from "../../../library-js/dom/DOMOrientation";
import { AttributeValue } from "../../../library-js/dom-tools/AttributeValue";

export class YoutubePlayer
{
  static isAllowed:boolean = true;
  static COOKIE_NAME = "youtube-player";
  static noPlayer = new ElementAttribute( "no-player" );
  

  static isYoutubeLink( link:string )
  {
    link = RegExpUtility.trimProtocols( link );
    
    let youtubeEmbedDomains = 
    [
      "youtu.be/embed/", 
      "youtube.com/embed/",
      "www.youtube.com/embed/"
    ];

    // console.log( "Checking link:", link );

    return RegExpUtility.startsWithSome( link, youtubeEmbedDomains );
  }


  static applyOnDocument()
  {
    
    
    this.checkStatus();

    ElementType.anchor.forAllInDoc(
      ( a )=>
      {
        let value = ElementAttribute.href.from( a );
        
        if ( ! value )
        {
          return;
        }

        if ( YoutubePlayer.noPlayer.in( a ) )
        {
          // console.log( "NO YOUTUBE PLAYER >> ", a )
          return;
        }

        if ( ! YoutubePlayer.isYoutubeLink( value ) )
        {
          // console.log( "NO LINK YOUTUBE PLAYER >> ", a )
          return;
        }

        YoutubePlayer.applyOnElement( a );
      }
    )
  }

  static async setPlayerAllowance( flag:boolean )
  {
    let value = flag === true ? "true" : "false";
    let response = await Cookies.set( Rokojori.phpContext, YoutubePlayer.COOKIE_NAME, value );

    return response;
  } 



  static async checkStatus()
  {
    if ( this.isAllowed !== undefined )
    {
      return; 
    }

    let cookieResponse = await Cookies.get( Rokojori.phpContext, YoutubePlayer.COOKIE_NAME );
    
    if ( cookieResponse && cookieResponse.value === "true" )
    {
      YoutubePlayer.isAllowed = true;
    }
    else
    {
      YoutubePlayer.isAllowed = false;
    }
  }

  static centerVertically = new ClassFlag( "center-vertically" );

  static applyOnElement( e:HTMLElement )
  { 
    console.log( "LINK YOUTUBE PLAYER >> ", e )

    SmartLink.create( 
      e as HTMLAnchorElement, 
      {
        onSmartLink:( href:string )=> 
        {
          YoutubePlayer.show( href ) 
        }
      } 
    );
  }

  static async show( link:string )
  {

    let contentLib:
    {
      en:string,
      de:string
    } = 
    {
      "en": 
      ` 
        This is will open a video on <a href="https://youtube.com">YouTube</a>.
        <br>
        You need to accept YouTube's terms of use to continue by clicking
        OK. 
      `,

      "de":
      `
        Das öffnet ein Video von <a href="https://youtube.com">YouTube</a>.
        <br>
        Um fort zu fahren musst du deren Nutzungbedinungen akzeptieren, indem du 
        OK klickst. 
      `

      
    }
      

      
    let language = Rokojori.$.pageHandler.currentLanguage as ( "en" );

    if ( ! contentLib.hasOwnProperty( language ) )
    {
      language = "en";
    }

    let title = HTMLEditor.stringToWrappedElement( "YouTube Player", "youtube-tou-title" );
    let content = HTMLEditor.stringToWrappedElement( contentLib[ language ], "youtube-tou-info" );

    if ( ! YoutubePlayer.isAllowed )
    {
      let result = await OverlayHint.hint( title, content );

      console.log( "YT RESULT:", result, result.action, result.confirmed );

      if ( result.confirmed )
      {
        YoutubePlayer.setPlayerAllowance( true );
      }
      else
      {
        YoutubePlayer.setPlayerAllowance( false );

        return;
      }
    }
    

    let iframe = ElementType.iframe.create();

    YoutubePlayer.centerVertically.set( iframe );

    let scale = DOMOrientation.isLandscape ? 1/1.5 : 1 ;
    let width = window.innerWidth;


    ElementAttribute.width.to( iframe, ( width * scale ) + "" );
    ElementAttribute.height.to( iframe, ( width * scale * 9/16 ) + "" );
    ElementAttribute.title.to( iframe, "ROKOJORI YouTube Video Player" );
    ElementAttribute.frameborder.to( iframe, 0 + "" );
    ElementAttribute.allowfullscreen.to( iframe );
    ElementAttribute.allow.to( iframe, "autoplay; encrypted-media;" );

    ElementAttribute.src.to( iframe, link );

    Overlay.show( iframe );

    
    // <iframe width="1280" height="720" src="https://www.youtube.com/embed/PdX7oyo2x-Q" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
  }
}